"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.equal = exports.scales = undefined;

require("core-js/stable");

require("regenerator-runtime/runtime");

var _index = require("../vendor/number-sequences/dist/index.js");

var a = void 0,
    b = void 0; /**
                 * Scales
                 * @module client/lib/scales.js;
                 */

var scales = exports.scales = [{ name: "natural", get: function get(i, j) {
    return [i + 1, j + 1];
  } }, { name: "undertone", get: function get(i, j) {
    return [i + 1, i + j + 2];
  } }, { name: "overtone", get: function get(i, j) {
    return [i + j + 2, j + 1];
  } }, {
  name: "primes",
  reset: function reset(x, y, w, h) {
    a = (0, _index.Prime)().skip(x).take(w).toJS();
    b = (0, _index.Prime)().skip(y).take(h).toJS();
  },
  get: function get(ii, jj, i, j) {
    return [a[i], b[j]];
  }
}, {
  name: "arithmetic",
  reset: function reset(x, y, w, h) {
    a = (0, _index.Arithmetic)(x + 1, x + 1).take(w).toJS();
    b = (0, _index.Arithmetic)(y + 1, y + 1).take(h).toJS();
    // console.log(a);
  },
  get: function get(ii, jj, i, j) {
    return [a[i], b[j]];
  }
}, {
  name: "hyperbolic",
  get: function get(ii, jj, i, j, x, y) {
    return [1 + i * (x + 1) / (y + 1), 1 + j * (x + 1) / (y + 1)];
  }
},
// {
//   name: "triangle",
//   reset: (x, y, w, h) => {
//     a = Triangle().skip(x).take(w).toJS();
//     b = Triangle().skip(y).take(h).toJS();
//   },
//   get: (ii, jj, i, j) => [a[i], b[j]],
// },
{
  name: "collatz",
  reset: function reset(x, y, w, h) {
    a = (0, _index.Collatz)(x + 1).take(w).toJS();
    b = (0, _index.Collatz)(y + 1).take(h).toJS();
  },
  get: function get(ii, jj, i, j) {
    return [a[i], b[j]];
  }
}, {
  name: "pythagorean",
  get: function get(i, j) {
    return i < j ? [Math.pow(3, i + 1), Math.pow(2, j + Math.ceil(Math.max(0, i * 1.0 / 2)))] : [Math.pow(2, i + Math.ceil(Math.max(0, j * 1.2 / 2))), Math.pow(3, j)];
  }
}];

var equal = exports.equal = { name: "equal", get: function get(i, j) {
    return [i, j + 1];
  } };


//////////////////
// WEBPACK FOOTER
// ./client/lib/scales.js
// module id = 267
// module chunks = 0